
import React from "react";

const userContext = React.createContext();

export default userContext;
